import { NgModule } from '@angular/core';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LookupInterceptor } from './interceptors/lookup.interceptor';
import { LookupService } from './services/lookup.service';
import { ViewModelModelMappingService } from './services/view-model-model-mapping.service';
import { ViewModelService } from './services/view-model.service';
import { ResponseMessagesInterceptor } from './interceptors/response-messages.interceptor';
import { ToastService } from './services/toast.service';
import { MessageService } from 'primeng/api';
import { CoreComponent } from './core.component';
import { RequestSanitizerInterceptor } from "./interceptors/request-sanitizer.interceptor";
import { GeographyService } from "./services/geography.service";
import { NdmsConfirmService } from './services/ndms-confirm.service';
import { NdmsConfirmRemoveService } from './services/ndms-confirm-remove.service';
import {ApiAuthService} from "./services/apiauth.service";
import {NdmsAuthRequestInterceptor} from "./interceptors/ndms-auth-request.interceptor";
import {NdmsAuthenticationGuard} from "./interceptors/ndms-authentication.guard";
import {AuthModule, OidcSecurityService} from "angular-auth-oidc-client";
import { ConfirmPasswordValidatorDirective } from './validators/confirm-password-validator.directive';
import {BackProcessorService} from "./services/back-processor.service";

@NgModule({
  imports: [ AuthModule.forRoot() ],
  declarations: [
    CoreComponent,
    ConfirmPasswordValidatorDirective
  ],
  exports: [],
  providers: [
    BackProcessorService,
    LookupService,
    ToastService,
    MessageService,
    ViewModelModelMappingService,
    ViewModelService,
    GeographyService,
    ApiAuthService,
    NdmsConfirmService,
    NdmsConfirmRemoveService,
    NdmsAuthenticationGuard,
    OidcSecurityService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LookupInterceptor,
      multi: true
    },{
      provide: HTTP_INTERCEPTORS,
      useClass: NdmsAuthRequestInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResponseMessagesInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestSanitizerInterceptor,
      multi: true,
    }
  ]
})
export class CoreModule { }
